// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const projectActivityLogsQuery = gql`
  query projectActivityLogs($input: ProjectActivityLogsInput) {
    projectActivityLogs(input: $input) {
      message
      tip
      name
      logoUrl
      createdAt
    }
  }
`;
